import React from 'react';

import {
  HomeOutlined,
  FormOutlined,
  UserOutlined,
  TableOutlined,
  DollarCircleOutlined,
} from '@ant-design/icons';

const menuList = [
  {
    icon: <HomeOutlined />,
    title: '学生搜索',
    key: '/home',
  },
  {
    icon: <UserOutlined />,
    title: '用户信息',
    key: '/profile',
  },
  {
    icon: <FormOutlined />,
    title: '\u767b\u8bb0',
    key: '/form',
    children: [
      {
        icon: '',
        title: '\u4e0a\u8bfe\u767b\u8bb0',
        key: '/form/feedback',
      },
    ],
  },
  {
    icon: <TableOutlined />,
    title: '\u8868\u683c',
    key: '/table',
    children: [
      {
        icon: '',
        title: '\u62a5\u8bfe\u8868\u683c',
        key: '/table/enrollment',
      },
      {
        icon: '',
        title: '\u4e0a\u8bfe\u8868\u683c',
        key: '/table/feedback',
      },
      {
        icon: '',
        title: '结课续课表格',
        key: '/table/course-renewal',
      },
    ],
  },
  {
    icon: <DollarCircleOutlined />,
    title: '\u5de5\u8d44\u62a5\u544a',
    key: '/profile/salary',
  },
];

export default menuList;
